import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NavigationContext = createContext();

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within NavigationProvider');
  }
  return context;
};

export const NavigationProvider = ({ children }) => {
  const [isNavigating, setIsNavigating] = useState(false);
  const [targetPath, setTargetPath] = useState(null);
  const location = useLocation();

  // Reset navigation state when location changes
  useEffect(() => {
    if (targetPath && location.pathname === targetPath) {
      // Navigation complete
      setIsNavigating(false);
      setTargetPath(null);
    }
  }, [location, targetPath]);

  const startNavigation = (path) => {
    setTargetPath(path);
    setIsNavigating(true);
  };

  const endNavigation = () => {
    setIsNavigating(false);
    setTargetPath(null);
  };

  return (
    <NavigationContext.Provider value={{ isNavigating, startNavigation, endNavigation }}>
      {children}
      {isNavigating && (
        <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 shadow-xl">
            <div className="flex items-center space-x-3">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <span className="text-gray-700 font-medium">Navigating...</span>
            </div>
          </div>
        </div>
      )}
    </NavigationContext.Provider>
  );
};